import type { Component } from '../router';
import { icon, type IconName } from '../components/icons';

/**
 * Coming-soon placeholder for routes whose modules haven't shipped yet
 * (Module A, Module B, Reports). Keeping the tabs visible communicates the
 * product shape; this page makes tapping one an honest answer instead of
 * silently re-rendering Home.
 */

export interface ComingSoonOptions {
  icon: IconName;
  title: string;
  copy: string;
}

export class ComingSoonView implements Component {
  private root: HTMLElement | null = null;

  constructor(private opts: ComingSoonOptions) {}

  mount(host: HTMLElement): void {
    const section = document.createElement('section');
    section.className = 'comingsoon';

    const iconBox = document.createElement('div');
    iconBox.className = 'comingsoon__icon';
    iconBox.appendChild(icon(this.opts.icon));

    const title = document.createElement('h1');
    title.className = 'comingsoon__title';
    title.textContent = this.opts.title;

    const copy = document.createElement('p');
    copy.className = 'comingsoon__copy';
    copy.textContent = this.opts.copy;

    section.append(iconBox, title, copy);
    host.append(section);
    this.root = section;
  }

  unmount(): void {
    this.root?.remove();
    this.root = null;
  }
}

export function ComingSoonPage(opts: ComingSoonOptions): Component {
  return new ComingSoonView(opts);
}
